// @flow
import * as React from 'react';
import { Button } from 'grommet';
import { withTable } from 'speed-js-react-web';


type Props = {
    icon: React.Node,
    row: Object,
    showCondition?: (row: Object) => boolean,
    onClick: (row: Object) => void,

    table: { reloadTable: Function },
};

const ButtonComponent = (props: Props) => {
    const {
        icon, row, showCondition, onClick, table: { reloadData },
    } = props;

    return showCondition ? (
        <Button
            icon={icon}
            onClick={() => {
                onClick(row, reloadData);
            }}
            plain={false}
        />
    ) : null;
};

ButtonComponent.defaultProps = {
    showCondition: true,
};

export default withTable(ButtonComponent);
